/**
 * 侧边栏：我的主播
 * @author fulh
 * @update 2015-01-21 20:31:16
 */
$.module('MM.fixedbar.follow', function () {
  var MAIN = null,
    TMPL = MM.fixedbar.tmpl,
    ACTIONS = {
      follow: 'user/following_list/{access_token}',
      subscribe: MM.core.getRoot('api/v1/funnyRoomSubscribe/list', 'cryolite'),
      manage: 'user/managed_rooms/{access_token}',
      sign: 'broker/star_list/{access_token}?hide=true&size=100',
      family: 'familyroom/following_list?access_token={access_token}',
    };

  function _show() {
    MAIN = MM.fixedbar.main;
    MAIN.initDialog(
      $.template(TMPL.follow, MM.user.getUserInfo()),
      true,
      'follow',
    );
    _renderList();
    _registerEvents();
  }

  function _renderList() {
    var $container = $('#j_fixedbar_follow_follow').show();
    $container.siblings().hide();
    MM.ui.base.autoRender({
      selector: $container,
      requireToken: true,
      url: ACTIONS.follow,
      template: TMPL.follow_list_follow,
      successCallback: function () {
        MAIN.showDialog('follow');
      },
    });
  }
  function _registerEvents() {
    $('#j_fixedbar_follow .fixedbar-follow-hd a').click(function (e) {
      e.preventDefault();
      var type = $(this).data('type');
      $(this).addClass('on').siblings().removeClass('on');

      _track($(this).text());
      var $container = $('#j_fixedbar_follow_' + type).show();
      $('#j_fixedbar_follow').attr('data-type', type);
      $container.siblings().hide();
      MM.ui.base.autoRender({
        selector: $container,
        requireToken: true,
        url: ACTIONS[type],
        template: TMPL['follow_list_' + type],
        successCallback: function ($selector, res) {
          var nodataTip = {
            follow: '暂无关注的主播，点击直播间视频右上方关注主播哦！',
            subscribe: '暂无订阅的多人厅哦~',
            manage:
              '暂无管理的主播，给喜欢的主播送礼有机会成为她的房间管理哦！',
            sign: '暂无签约的主播',
            family: '暂无关注的家族房，点击直播间视频右上方关注主播哦！',
          };
          if (!res.data.users || res.data.users.length == 0) {
            $selector.find('.text-info').text(nodataTip[type]);
          }
        },
      });
    });
  }

  function _track(action) {
    MM.common.track('边栏_我的主播', action);
  }

  return {
    show: _show,
  };
});
